<h1>Möchten Sie den Benutzer {{username}} wirklich {{activate?'aktivieren':'deaktivieren'}}?</h1>

<div class="div-footer">
  <span></span>
  <button mat-raised-button color="warn" (click)="act()">Benutzer {{activate?'aktivieren':'deaktivieren'}}</button>
  <button mat-button color="primary" (click)="close()">Abbrechen</button>
</div>